import { IconBrandWhatsapp, IconCheck, IconInfoCircle, IconMinus, IconPlus, IconShoppingCartFilled, IconX } from '@tabler/icons-react';
import { Card, Text, Group, Button, ActionIcon, useMantineTheme, Grid, TextInput, Select, NumberInput, NumberInputHandlers, Accordion, Stack, Box, Radio, Notification, rem, Alert, CheckIcon, Checkbox, Chip } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useForm } from '@mantine/form';
import axios from 'axios';
import Wilayas from './../../helper/wilayas.json';
import Communes from './../../helper/communes.json';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'universal-cookie';
import useStore from '../../store/useStore';
const cookies = new Cookies(null, { path: '/' });

interface Props {
    data: any;
    marketer: any;
}

export function FormOrder({data, marketer}: Props) {
    const theme = useMantineTheme();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const handlersRef = useRef<NumberInputHandlers>(null);
    const {onSubmit, reset, values, getInputProps, errors, setValues} = useForm({
        initialValues: {
            name: '', phone: "", state: "", city: "", quantity: 1, typeFee: "desk_fee", address: "", sizes: [], colors: []
        },
        validate: {
            name: (value) => (value?.length < 2 ? 'الاسم غير صالح' : null),
            phone: (value: string) => (/^(05|06|07)[0-9]{8}$/.test(value) ? null : 'رقم الهاتف غير صالح'),
            state: (value) => (parseInt(value) <= 0 ? 'لم تختار ولاية بعد' : null),
            city: (value) => (parseInt(value) <= 0 ? 'لم تختار بلدية بعد' : null),
            quantity: (value) => (value < 1 ? 'الكمية يجب ان تكون 1 او اكثر' : null),
            typeFee: (value) => (value?.length < 2 ? 'لم تختار نوع التوصيل بعد' : null),
            address: (value) => (value?.length < 2 ? 'العنوان غير صالح' : null),
        },
        validateInputOnBlur: true,
        validateInputOnChange: true
    });
    const {onSubmit: onSubmit2, reset: reset2, values: values2, getInputProps: getInputProps2} = useForm({
        initialValues: {
            coupon: ''
        }
    });
    const [allWilayas, setAllWilayas] = useState<{label: string, value: string}[]>([])
    const [allCommunes, setAllCommunes] = useState<{label: string, value: string}[]>([])
    const [delivery, setDelivery] = useState<any>(null)
    const [offerSelected, setOfferSelected] = useState("none");
    const [price, setPrice] = useState(0);
    const [deliveryPrice, setDeliveryPrice] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [facebookApis, setFacebookApis] = useState<any[]>([]);
    const dataStore = useStore((state: any) => state.store);
    let [myIP, setMyIP] = useState<string>("");
    let [coupon, setCoupon] = useState<{coupon: string; discount: number;}>({coupon: "", discount: 0});
    
    useEffect(() => {
        axios.get(`https://api.ipify.org/?format=json`)
        .then(({data}) => {
            setMyIP(data.ip);
        })
        .catch((error) => console.log(error))

        axios.get(`${process.env.REACT_APP_API_URL}/pixels`)
        .then(({data}) => {
            const advancedMatching = undefined;
            data?.map((item: any, index: number) => {
                if (item?.apiKey !== "" && item?.apiKey.length > 10) {
                    ReactPixel.init(item?.apiKey, advancedMatching, {
                        autoConfig: true,
                        debug: true
                    });
                }
            })
            ReactPixel.pageView();
        })
        .catch((error) => console.log(error));
    }, [])
    useEffect(() => {
        if (marketer && marketer?._id && marketer?._id !== "") {
            axios.get(`${process.env.REACT_APP_API_URL}/pixels?idMarketer=${marketer?._id}`)
            .then(({data}) => {
                const advancedMatching = undefined;
                data?.map((item: any, index: number) => {
                    if (item?.apiKey !== "" && item?.apiKey.length > 10) {
                        ReactPixel.init(item?.apiKey, advancedMatching, {
                            autoConfig: true,
                            debug: true
                        });
                    }
                })
                ReactPixel.pageView();
            })
            .catch((error) => console.log(error));
        }
    }, [marketer])

    useEffect(() => {
        if (Wilayas?.length > 0) {
            let newData: {label: string, value: string}[] = []
            Wilayas?.map((item: any) => {
                newData.push({label: item?.name, value: item?.id?.toString()})
            })
            setAllWilayas(newData)
        }
    }, [])

    useEffect(() => {
        if (values.state && values.state !== "") {
            if (Communes?.length > 0) {
                const filterdCommunes = Communes?.filter((item: any) => item.wilaya == values.state)
                let newData: {label: string, value: string}[] = []
                filterdCommunes.map((item: any) => {
                    newData.push({label: item?.name, value: item?.id?.toString()})
                })
                setAllCommunes(newData)
            }

            axios.get(`${process.env.REACT_APP_API_URL}/deliveryfees/${values.state}`)
            .then(({data}) => {
                setDelivery(data)
                setDeliveryPrice((values.typeFee === "desk_fee" ? data?.desk_fee : data?.home_fee) || 0)
            })
            .catch((error) => console.log(error));
        }
    }, [values.state])

    useEffect(() => {
        if (data) {
            setPrice(data?.priceAfterDiscount > 0 ? data?.priceAfterDiscount + (marketer?.priceMarketer || 0) : data?.price + (marketer?.priceMarketer || 0))
            setDeliveryPrice(0)
        }
    }, [data])

    useEffect(() => {
        setDeliveryPrice((values.typeFee === "desk_fee" ? delivery?.desk_fee : delivery?.home_fee) || 0)
    }, [values.typeFee])

    useEffect(() => {
        setQuantity(values.quantity)
        if (values.quantity < values.sizes.length) {
            setValues({sizes: []})
        }
        if (values.quantity < values.colors.length) {
            setValues({colors: []})
        }
    }, [values.quantity])

    useEffect(() => {
        if (offerSelected !== "none") {
            const offerFiltered = data?.offers?.filter((item: any) => item?.name === offerSelected)
            if (offerFiltered?.length > 0) {
                const offer = offerFiltered[0]
                setPrice(parseFloat((offer?.price / offer?.quantity)?.toFixed(2)))
                setDeliveryPrice(offer?.freeShipping ? 0 : ((values.typeFee === "desk_fee" ? delivery?.desk_fee : delivery?.home_fee) || 0))
                setQuantity(offer?.quantity)
            }
        } else {
            setPrice(data?.priceAfterDiscount > 0 ? data?.priceAfterDiscount + (marketer?.priceMarketer || 0) : data?.price + (marketer?.priceMarketer || 0))
            setDeliveryPrice((values.typeFee === "desk_fee" ? delivery?.desk_fee : delivery?.home_fee) || 0)
            setQuantity(values.quantity)
        }
    }, [offerSelected])

    const onSubmitForm = ({name, phone, state, city, typeFee, address, sizes, colors}: any) => {
        const {_id} = data

        const stateName = allWilayas.filter(item => item.value === state)
        const cityName = allCommunes.filter(item => item.value === city)

        axios.post(`${process.env.REACT_APP_API_URL}/orders`, {
            "fullName": name,
            "phone": phone,
            "state": stateName[0].label,
            "city": cityName[0].label,
            
            "typeFee": typeFee,
            "address": address,
            "deliveryPrice": deliveryPrice,

            "sizes": sizes,
            "colors": colors,
            "ipAddress": myIP,

            "price": (price - (marketer?.priceMarketer || 0)) - (((price - (marketer?.priceMarketer || 0)) * coupon.discount) / 100),
            "quantity": quantity,

            "coupon": coupon.coupon,
            "discountCoupon": coupon.discount,
            "idProduct": _id,

            referralCode: marketer ? marketer?.referralCode : "",
            priceMarketer: marketer ? marketer?.priceMarketer : 0,
        })
        .then(({data}) => {
            if (data.code === "MANY_REQUESTS") {
                navigate(`/order/failed/product/${_id}/many`)
            } else {
                navigate(`/order/confirmed/product/${_id}/one/${marketer ? marketer?.referralCode : ""}`)
            }
            onReset()
        })
        .catch((error) => {
            console.log(error)
            navigate(`/order/failed/product/${_id}`)
            // setTealAlert(false)
            // setRedAlert(true)
        });
    }

    const onSubmitAbandoned = () => {
        const {_id, price, priceAfterDiscount} = data
        
        if (/^(05|06|07)[0-9]{8}$/.test(values?.phone)) {
            axios.post(`${process.env.REACT_APP_API_URL}/cart-abandoned`, {
                "fullName": values?.name || "",
                "phone": values?.phone,
                "state": "",
                "city": "",
                
                "typeFee": "desk_fee",
                "address": values?.address || "",
                "deliveryPrice": delivery?.desk_fee || 0,

                "price": priceAfterDiscount > 0 ? priceAfterDiscount : price,
                "quantity": 1,
                "idProduct": _id,
                referralCode: marketer ? marketer?.referralCode : "",
                priceMarketer: marketer ? marketer?.priceMarketer : 0,
            })
            .then(({data}) => console.log(data))
            .catch((error) => console.log(error));
        }
    }

    const onSubmitCoupon = () => {
        if (values2.coupon !== "") {
            axios.get(`${process.env.REACT_APP_API_URL}/coupons-has-valid/${values2.coupon}`)
            .then(({data}) => {
                if (data !== null && data?.coupon ) {
                    setCoupon({ coupon: data.coupon, discount: data.discountPercentage })
                } else {
                    setCoupon({ coupon: "", discount: 0 })
                }
            })
            .catch((error) => setCoupon({ coupon: "", discount: 0 }));
        }
    }

    const onReset = () => {
        reset()
        reset2()
        setDelivery(null)
        setPrice((data?.priceAfterDiscount > 0 ? data?.priceAfterDiscount + (marketer?.priceMarketer || 0) : data?.price + (marketer?.priceMarketer || 0)))
        setDeliveryPrice(0)
        setQuantity(0)
        setCoupon({ coupon: "", discount: 0 })
    }

    return (
        <Card withBorder radius="md" p={30} style={{border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}`}}>
            <Text ta={'center'} fw={700} >أضف معلوماتك في الأسفل لطلب هذا المنتج</Text>

            <form onSubmit={onSubmit(onSubmitForm)}>
                <Grid mt={30}>
                    <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                        <TextInput
                            placeholder="الاسم الكامل"
                            size='lg'
                            styles={{
                                input: {
                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                },
                            }}
                            {...getInputProps('name')}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                        <TextInput
                            placeholder="رقم الهاتف"
                            size='lg'
                            styles={{
                                input: {
                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                },
                            }}
                            {...getInputProps('phone')}
                            onBlur={onSubmitAbandoned}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                        <Select
                            placeholder="الولاية"
                            data={allWilayas}
                            size='lg'
                            styles={{
                                input: {
                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                },
                                dropdown: {
                                    boxShadow: "0px 1px 11px 2px rgb(0 0 0/15%)"
                                }
                            }}
                            {...getInputProps('state')}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                        <Select
                            placeholder="البلدية"
                            data={allCommunes}
                            size='lg'
                            styles={{
                                input: {
                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                },
                                dropdown: {
                                    boxShadow: "0px 1px 11px 2px rgb(0 0 0/15%)"
                                }
                            }}
                            {...getInputProps('city')}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                        <TextInput
                            placeholder="العنوان"
                            size='lg'
                            styles={{
                                input: {
                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                },
                            }}
                            {...getInputProps('address')}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                        <Select
                            placeholder="نوع التوصيل"
                            data={[
                                {label: "توصيل للمكتب", value: "desk_fee"},
                                {label: "توصيل للبيت", value: "home_fee"}
                            ]}
                            size='lg'
                            styles={{
                                input: {
                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                },
                                dropdown: {
                                    boxShadow: "0px 1px 11px 2px rgb(0 0 0/15%)"
                                }
                            }}
                            {...getInputProps('typeFee')}
                            allowDeselect={false}
                        />
                    </Grid.Col>
                    {data?.sizes && data?.sizes?.length > 0
                        ? <Grid.Col span={{ base: 12 }}>
                            {/* //"اختر الحجم او الاحجام"  */}
                            <Chip.Group multiple={true} {...getInputProps("sizes")} >
                                <Group mt="xs">
                                    {data?.sizes.map((item: any, index: number) => (
                                        <Chip
                                            key={index} color={dataStore?.information?.backgroundColor || "#645cbb"} value={item} radius="sm"
                                            disabled={values.sizes.length >= quantity && !values.sizes.includes(item as never)}
                                        >{item}</Chip>
                                    ))}
                                </Group>
                            </Chip.Group>
                        </Grid.Col>
                        : null
                    }

                    {data?.colors && data?.colors?.length > 0
                        ? <Grid.Col span={{ base: 12 }}>
                            <Checkbox.Group label="اختر اللون او الالوان" {...getInputProps("colors")}>
                                <Group mt="xs">
                                    {data?.colors.map((item: any, index: number) => (
                                        <Checkbox
                                            key={index} color={item} value={item} label=""
                                            disabled={values.colors.length >= quantity && !values.colors.includes(item as never)}
                                            
                                            styles={{
                                                input: {
                                                    backgroundColor: item
                                                }
                                            }}
                                            icon={({ indeterminate, ...others }) =>
                                                indeterminate ? <IconMinus {...others} /> : <IconCheck stroke={2} color={["#FFFFFFFF", "#9E9E9EFF"].includes(item) ?  "#000" : "#fff"} {...others} />
                                            }
                                        />
                                    ))}
                                </Group>
                            </Checkbox.Group>
                        </Grid.Col>
                        : null
                    }

                    {data?.offers && data?.offers?.length > 0 && !marketer
                        ? <Grid.Col span={{ base: 12 }}>
                            <Radio.Group name="favoriteFramework" withAsterisk value={offerSelected} onChange={setOfferSelected} >
                                <Stack mt="xs">
                                    <Radio
                                        icon={CheckIcon} value="none" color={dataStore?.information?.backgroundColor || "#645cbb"}
                                        label={
                                            <Group justify='space-between'>
                                                <Text fw={700} c={"gray.7"} >{"بدون عرض"}</Text>
                                                <Text fw={700} c={dataStore?.information?.backgroundColor || "#645cbb"} ></Text>
                                            </Group>
                                        }
                                        styles={()=>({
                                            root: {
                                                background: "#fff",
                                                border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`,
                                                borderRadius: 3,
                                                padding: "12px 10px"
                                            },
                                            body: { justifyContent: "flex-start" },
                                            labelWrapper: { width: "100%" },
                                            label: { width: "100%" }
                                        })}
                                    />
                                    {data?.offers.map((item: any, index: number) => (
                                        <Radio
                                            key={index} icon={CheckIcon}
                                            value={item?.name} color={dataStore?.information?.backgroundColor || "#645cbb"}
                                            label={
                                                <Group justify='space-between'>
                                                    <Text fw={700} c={"gray.7"} >{item?.name}</Text>
                                                    <Text fw={700} c={dataStore?.information?.backgroundColor || "#645cbb"} >
                                                        {item?.price} د.ج
                                                    </Text>
                                                </Group>
                                            }
                                            styles={()=>({
                                                root: {
                                                    background: "#fff",
                                                    border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`,
                                                    borderRadius: 3,
                                                    padding: "12px 10px"
                                                },
                                                body: { justifyContent: "flex-start" },
                                                labelWrapper: { width: "100%" },
                                                label: { width: "100%" }
                                            })}
                                        />
                                    ))}
                                </Stack>
                            </Radio.Group>
                        </Grid.Col>
                        : null
                    }

                    {process.env.REACT_APP_PAGE_COUPON_DISPLAY == "true" && !marketer
                        ? <Grid.Col span={{ base: 12 }}>
                            <TextInput
                                placeholder="الكوبون"
                                size='lg'
                                styles={{
                                    input: {
                                        border: `2px solid ${dataStore?.information?.backgroundColor || "#48a172"}7d`
                                    },
                                }}
                                {...getInputProps2('coupon')}
                                rightSectionWidth={70}
                                rightSection={
                                    <Button
                                        px={10}
                                        variant="default"
                                        disabled={values2.coupon === ""}
                                        onClick={onSubmitCoupon}
                                    >تحقق</Button>
                                }
                            />
                        </Grid.Col>
                        : null
                    }

                    {offerSelected === "none"
                        ? <Grid.Col span={{ base: 12, sm: 12, md: 3 }}>
                            <NumberInput
                                handlersRef={handlersRef}
                                {...getInputProps('quantity')}
                                min={1}
                                size='lg'
                                styles={{
                                    input: {
                                        border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`,
                                        color: theme.colors.dark[3],
                                        fontWeight: 600,
                                        paddingInlineStart: 40,
                                        paddingInlineEnd: 40,
                                        textAlign: 'center'
                                    }
                                }}
                                rightSection ={
                                    <ActionIcon
                                        variant="transparent" h={"100%"} w={40} radius={0} 
                                        style={{borderRight: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`}}
                                        onClick={() => handlersRef.current?.decrement()}
                                    >
                                        <IconMinus size={18} color={theme.colors.dark[2]} stroke={2} />
                                    </ActionIcon>
                                }
                                rightSectionWidth={40}
                                leftSection={
                                    <ActionIcon 
                                        variant="transparent" h={"100%"} w={40} radius={0} 
                                        style={{borderLeft: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`}}
                                        onClick={() => handlersRef.current?.increment()}
                                    >
                                        <IconPlus size={18} color={theme.colors.dark[2]} stroke={2} />
                                    </ActionIcon>
                                }
                                leftSectionWidth={40}
                            />
                        </Grid.Col>
                        : null
                    }
                    
                    <Grid.Col span={{ base: 12, sm: 12, md: offerSelected === "none" ? 9 : 12 }}>
                        <Button 
                            type='submit' fullWidth variant="filled" c={dataStore?.information?.textColor || "#fff"}
                            size='lg' color={dataStore?.information?.backgroundColor || "#645cbb"} disabled={Object.keys(errors)?.length > 0}
                        >انقر هنا لتأكيد الطلب</Button>
                    </Grid.Col>
                </Grid>
            </form>

            {dataStore?.information?.phone
                ? <Group justify='center' mt={20}>
                    <Button
                        variant="filled" radius={'lg'} color={'green'}
                        leftSection={<IconBrandWhatsapp size={18} />}
                        component='a'
                        href={`https://wa.me/${dataStore?.information?.phone}`}
                    >أنقر هنا للطلب عبر الواتساب</Button>
                </Group>
                : null
            }

            <Accordion
                mt={20} variant="filled" defaultValue="1"
                style={{background: theme.colors.gray[0]}}
                styles={{
                    label: {
                        fontWeight: 700,
                        color: theme.colors.gray[7]
                    },
                    icon: {
                        color: theme.colors.gray[5]
                    },
                    content: {
                        padding: 0
                    }
                }}
            >
                <Accordion.Item value="1" style={{background: theme.colors.gray[0]}}>
                    <Accordion.Control style={{borderBottom: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`}} icon={<IconShoppingCartFilled size={26} /> } >ملخص الطلب</Accordion.Control>
                    <Accordion.Panel p={10}>
                        <Stack gap={0}>
                            <Group justify='space-between' style={{borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#645cbb"}7d`}} py={10}>
                                <Text flex={4} fw={700} c={"gray.7"} >{data?.name}</Text>
                                
                                <Text flex={1} fw={700} c={"gray.7"} >
                                    <Text span={true} size='xs' fw={700} c={theme.white} bg={dataStore?.information?.backgroundColor || "#645cbb"} p={2} >{quantity}×</Text> {" "}
                                    {parseFloat(price?.toFixed(2))} د.ج
                                </Text>
                            </Group>
                            
                            <Group justify='space-between' align='center' style={{borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#645cbb"}7d`}} py={10}>
                                <Text flex={4} fw={700} c={"gray.7"} >سعر التوصيل</Text>
                                <Box flex={1}>
                                    {data?.freeShipping
                                        ? <Text fw={700} size='sm' maw={"fit-content"} c={theme.white} bg={dataStore?.information?.backgroundColor || "#645cbb"} p={5} >مجانا</Text>
                                        : <Text fw={700} size='sm' maw={"fit-content"} c={theme.white} bg={dataStore?.information?.backgroundColor || "#645cbb"} p={5} >{deliveryPrice} د.ج</Text>
                                    }
                                </Box>
                            </Group>
                            
                            {process.env.REACT_APP_PAGE_COUPON_DISPLAY == "true" && !marketer
                                ? <Group justify='space-between' align='center' style={{borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#48a172"}7d`}} py={10}>
                                    <Text flex={4} fw={700} c={"gray.7"} >التخفيض</Text>
                                    <Box flex={1}>
                                        <Text fw={700} size='sm' maw={"fit-content"} c={theme.white} bg={dataStore?.information?.backgroundColor || "#48a172"} p={5} >
                                            {Math.round((quantity * price * coupon.discount) / 100)} د.ج
                                        </Text>
                                    </Box>
                                </Group>
                                : null
                            }
                            
                            <Group justify='space-between' py={10}>
                                <Text flex={4} fw={700} c={"gray.7"} >السعر الإجمالي</Text>
                                
                                <Box flex={1}>
                                    <Text fw={700} c={dataStore?.information?.backgroundColor || "#645cbb"} >
                                        {data?.freeShipping
                                            ? Math.round((quantity * price) - ((quantity * price * coupon.discount) / 100))
                                            : Math.round((quantity * price) + deliveryPrice - ((quantity * price * coupon.discount) / 100))
                                        } د.ج
                                    </Text>
                                </Box>
                            </Group>
                        </Stack>
                    </Accordion.Panel>
                </Accordion.Item>
            </Accordion>
        </Card>
    );
}